import { CompleteStore } from '../../../../../reducers/reducerTypes';

export const getLoading = (state: CompleteStore): boolean => {
	return state.constants.loading;
};
